import * as React from "react";

import "./loadingPage.scss";

interface ILoadingPageProps {
    headline: string,
    message: string,
    isFullPage?: boolean
}

interface ILoadingPageState {
}

export class LoadingPage extends React.Component<ILoadingPageProps, ILoadingPageState> {

    constructor (props: ILoadingPageProps) {
        super(props);

        this.props = props;

        this.state = {

        }
    }
    
    render() {
        let classes = ["ncb-loadingPage", "ncb-container"];

        if (this.props.isFullPage === true)
            classes.push("fullscreen");

        return  <div className={classes.join(" ")}>
                    <div className="inner">
                        <div className="loading-icon"></div>
                        <h2>{this.props.headline}</h2>

                        <div className="ncb-loadingPage-message">{this.props.message.split(".").map(x => <div>{x}</div>)}</div>
                    </div>
                 </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/shared/loadingPage.tsx